import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  pusher: {
    padding: '0 2em',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: theme.spacing(1),
    alignItems: 'center',
    margin: '1em',
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    // marginBottom: theme.spacing(1),
  },
  instructionHeading: {
    border: '1px solid black',
  },
}));

export default function Instructions() {
  const classes = useStyles();

  return (
    <div className={classes.pusher}>
      <Grid container spacing={1} justify="center">
        <Grid item xs={12} style={{ justifyContent: 'left' }}>
          <Paper className={classes.paper}>
            <Typography display="block" variant="subtitle1" gutterBottom>
              Instructions
            </Typography>
            <Typography display="block" variant="subtitle1" gutterBottom>
              Upload images that feature a photojournalist and editorial style.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={6} style={{ justifyContent: 'left' }}>
          <Paper className={classes.paper}>
            <Typography display="block" variant="subtitle1" gutterBottom>
              TECHNICAL SPECS
            </Typography>
            <ul>
              <li>At least 2000 pixels on the longest side @180 ppi or higher</li>
              <li>JPEG files.</li>
              <li>Unedited.</li>
              <li>Unwatermarked.</li>
              <li>Free of borders, effects, album design pages, or diptychs.</li>
            </ul>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper className={classes.paper}>
            <Typography display="block" variant="subtitle1" gutterBottom>
              CONTENT SPECS
            </Typography>
            <ul>
              <li>Recent weddings from the past 3 years.</li>
              <li>No blurry / grainy / underexposed images.</li>
              <li>Showcase your best work! Magical compositions.</li>
              <li>More horizontals than verticals works best!</li>
              <li>Images from multiple weddings. Variety is key! </li>
              <li style={{ listStyleType: 'none' }}>&nbsp;</li>
            </ul>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper className={classes.paper}>
            <Typography display="block" variant="subtitle1" gutterBottom>
              WHAT NOT TO INCLUDE
            </Typography>
            <ul>
              <li>Mock-bridal shoots with a model.</li>
              <li>Formal posed images at the church.</li>
              <li>Food images.</li>
              <li>Images of random guests at the wedding.</li>
              <li>Anything you don't want in your official portfolio.</li>
            </ul>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
